import React from 'react';
import { identity } from 'lodash';
import { SimilarityRangeSliderBase } from './SimilarityRangeSliderBase';

export const PixelBasedPredictiveSimilarityRangeSlider = props => (
    <SimilarityRangeSliderBase min={1} max={5} step={1} valueLabelFormat={identity} {...props} />
);
